module.exports = __webpack_public_path__ + "img/登录验证3.09b95690.jpg";